import * as React from "react";
import {ChangeEvent} from "react";
import {InputFieldState} from "./InputFieldState";
import newId from "../helpers/NewId";


interface CheckBoxProps {
    label: string;
    state?: InputFieldState
    onChange?: (value: string, isChecked: boolean, event: ChangeEvent<HTMLInputElement>) => void;
    errorMessage?: string,
    insertDangerously?: boolean,
}

interface CheckBoxState {
    isChecked: boolean,
}

/**
 * Text Input Element
 */
export class CheckBox extends React.Component<CheckBoxProps, CheckBoxState> {

    state: CheckBoxState = {
        isChecked: false,
    };

    public static defaultProps = {
        label: "Label",
    };

    private id: string;

    componentWillMount() {
        this.id = newId();
    };

    componentDidUpdate(prevProps: Readonly<CheckBoxProps>) {
        if (this.props.state.isChecked !== prevProps.state.isChecked) {
            this.setState({isChecked: this.props.state.isChecked});
        }
    }

    constructor(props: any) {
        super(props);

        this.state = {
            isChecked: this.props.state.isChecked,
        }
    }

    render() {
        return <div>
            <label htmlFor={this.id}>
                <input id={this.id} checked={this.state.isChecked} readOnly={this.props.state.editable === false}
                       onChange={(event) => {
                           const newState = !this.state.isChecked;
                           this.setState({isChecked: newState});
                           this.props.onChange(event.target.value, newState, event);
                       }} value={this.props.state.value} type="checkbox"/>
                {this.props.insertDangerously &&
                    <span dangerouslySetInnerHTML={{__html: this.props.label}}/>
                }
                {!this.props.insertDangerously &&
                    <span>{this.props.label}</span>
                }

            </label>
            <div className="error_message">{this.props.state.errorMessage}</div>
        </div>
    }
}

/**
 <label for="gdpr" data-error="<?php echo $this->translate('Please check this box to proceed'); ?>">
 <input id="gdpr" type="checkbox" name="gdpr" value="on" required/>
 <span><?php echo $this->translate('I agree to the storage of my email address, name, and IP address'); ?></span></label>
 */